import { storableError } from '../../util/errors';
import { denormalisedResponseEntities } from '../../util/data';
import { currentUserShowSuccess } from '../../ducks/user.duck'; // ✅ import from existing user.duck

// Action types
export const SAVE_USER_ADDRESS_REQUEST = 'app/userAddress/SAVE_USER_ADDRESS_REQUEST';
export const SAVE_USER_ADDRESS_SUCCESS = 'app/userAddress/SAVE_USER_ADDRESS_SUCCESS';
export const SAVE_USER_ADDRESS_ERROR = 'app/userAddress/SAVE_USER_ADDRESS_ERROR';

// Initial state
const initialState = {
  saveInProgress: false,
  saveError: null,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_USER_ADDRESS_REQUEST:
      return { ...state, saveInProgress: true, saveError: null };
    case SAVE_USER_ADDRESS_SUCCESS:
      return { ...state, saveInProgress: false };
    case SAVE_USER_ADDRESS_ERROR:
      return { ...state, saveInProgress: false, saveError: action.error };
    default:
      return state;
  }
}

// Action creators
export const saveUserAddressRequest = () => ({ type: SAVE_USER_ADDRESS_REQUEST });
export const saveUserAddressSuccess = () => ({ type: SAVE_USER_ADDRESS_SUCCESS });
export const saveUserAddressError = error => ({ type: SAVE_USER_ADDRESS_ERROR, error });

// Thunk
export const saveUserAddress = address => (dispatch, getState, sdk) => {
  dispatch(saveUserAddressRequest());

  return sdk.currentUser
    .updateProfile({
      protectedData: {
        ResidentialAddress: address,
      },
    })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      const updatedUser = entities[0];

      dispatch(saveUserAddressSuccess());

      // dispatch(currentUserShowSuccess(updatedUser)); // ✅ Update Redux
      window.location.reload();

    })
    .catch(e => {
      dispatch(saveUserAddressError(storableError(e)));
      throw e;
    });
};
